var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundMain3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 666,
    viewBox: "0 0 1920 666",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_708_4869)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 666,
    fill: "#EAFFEA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 432,
    cy: 68,
    rx: 468,
    ry: 365,
    fill: "#00C500"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 432,
    cy: -15.5842,
    rx: 230.507,
    ry: 179.776,
    fill: "#00C500"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 1658.5,
    cy: 802.5,
    r: 535.5,
    fill: "#00C500"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 1658.5,
    cy: 679.871,
    r: 263.754,
    fill: "#00C500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_708_4869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 666,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundMain3);
export default __webpack_public_path__ + "static/media/background_main3.242074d18683b56db5019ddcd6748dfe.svg";
export { ForwardRef as ReactComponent };